import styled from 'styled-components'

import { _M_Normal, mainColors, medias, zIndex } from '../../styles'

export const REVIEW_CARD_MAX_WIDTH = 965

export const ReviewTimelineContainer = styled.div`
  position: relative;
  padding: 20px;
  overflow-x: auto;

  ${medias.MD_SCREEN`
    padding: 0 40px;

      &:not(:first-child) {
        padding-top: 40px;
      }

      &:last-child {
        padding-bottom: 40px;
      }
  `};
`

export const TimeLine = styled.div<{ shouldHideDate?: boolean }>`
  position: absolute;
  width: 1px;
  top: 0;
  left: ${({ shouldHideDate }) => (shouldHideDate ? 0 : '161px')};
  bottom: 0;
  border-left: 1px dashed ${mainColors.neutralDark};
`

const WITH_DATA_MARGIN_LEFT = 162
const WITHOUT_DATA_MARGIN_LEFT = 38

export const ReviewRightSide = styled.div<{ shouldHideDate?: boolean }>`
  margin-left: ${({ shouldHideDate }) =>
    shouldHideDate ? WITHOUT_DATA_MARGIN_LEFT : WITH_DATA_MARGIN_LEFT}px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ReviewContainer = styled.div`
  display: flex;
  gap: 24px;
`

export const TimelineDot = styled.div`
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  margin-top: 32px;
  margin-right: 10px;
  background-color: ${mainColors.accentMedium};
  border: 4px solid ${mainColors.accentExtremelyLight};
  border-radius: 50%;
  z-index: ${zIndex.DEFAULT};
`

export const CreatedAtDate = styled.p`
  ${_M_Normal};
  color: ${mainColors.neutralExtremelyDark};
  line-height: 150%;
  max-width: 90px;
  margin-top: 16px;
`
